import React from 'react'
import LoverIcon from "../../common/images-new/lover-icon.svg"
import { getProfilePic } from '../Helpers/Common';
import { useHistory } from "react-router-dom";
import { getUrl } from '../Helpers/Config';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';

const AvatarGroup = ({ likesList }) => {

    const history = useHistory()

    return (
        <div className="flex -space-x-4 overflow-hidden mr-2">
            {likesList.map((liker, index) => (
                <a target="_blank" href={getUrl("/profile/") + liker?.guid}>
                    <img
                        key={index}
                        className="w-9 h-9 inline-block rounded-full cursor-pointer"
                        alt="lover"
                        src={getProfilePic(liker.photo)}
                    >
                    </img>
                </a>
            ))}
            <span className='w-4 h-4 backGroundColor flex items-center justify-center rounded-full self-end'>
                <ThumbUpAltIcon style={{fontSize:'10px'}}  className={`likeIcon primaryIcon  w-1 h-1`} />
            </span>

            {/* <img
                className="w-4 h-4 inline-block rounded-full self-end"
                alt="love"
                src={LoverIcon}
            >
            </img> */}

        </div>

    )
}

export default AvatarGroup